import { SYSTEM_MSG_RECEIVED, USER_MSGS_RECEIVED, USER_MSGS_UNREAD, USER_MSG_CREATED, USER_MSG_UPDATED, CHANGE_LOG_RECEIVED } from './types'
import api from 'api'

export const systemMessageReceived = data => ({
  type: SYSTEM_MSG_RECEIVED,
  data
})

export const changelogReceived = data => ({
  type: CHANGE_LOG_RECEIVED,
  data
})

export const userMessagesReceived = data => ({
  type: USER_MSGS_RECEIVED,
  data
})

export const userMessagesUnread = data => ({
  type: USER_MSGS_UNREAD,
  data
})

export const userMessageUpdated = data => ({
  type: USER_MSG_UPDATED,
  data
})

export const userMessageAdded = data => ({
  type: USER_MSG_CREATED,
  data
})

export const getSystemMessage = () => (dispatch) =>
  api.system.getMessage().then( res => {
    dispatch(systemMessageReceived(res))
  })
 
export const getChangelog = (showAll) => (dispatch) =>
  api.system.getChangelog(showAll).then( res => {
    dispatch(changelogReceived(res))
  })
  
export const getUserMessages = (tag) => (dispatch) =>
  api.rnc.getUserMessages(tag).then( res => {
    dispatch(userMessagesReceived(res))
  })

export const getMessagesUnread = () => (dispatch) =>
  api.rnc.getMessagesUnread().then( res => {
    dispatch(userMessagesUnread(res))
  })

export const postUserMessage = (data, addTo) => dispatch =>
  api.rnc.postUserMessage(data).then( res => {
    if (addTo) {
      dispatch(userMessageAdded(res))
    } else {
      dispatch(userMessageUpdated(res))
    }
  })

export const updateUserMessageTag = (id, tag) => dispatch =>
  api.rnc.putUserMessage(id, tag).then( res => {
    dispatch(userMessageUpdated(res))
  })
  
export const deleteUserMessage = id => dispatch =>
  api.rnc.deleteUserMessage(id).then( res => {
    dispatch(userMessageUpdated(res))
  })